import { render, staticRenderFns } from "./KidzwonderJr.vue?vue&type=template&id=34330755&scoped=true"
import script from "./KidzwonderJr.vue?vue&type=script&lang=js"
export * from "./KidzwonderJr.vue?vue&type=script&lang=js"
import style0 from "./KidzwonderJr.vue?vue&type=style&index=0&id=34330755&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34330755",
  null
  
)

export default component.exports